<template>
  <div class="group-settings-container">

    <div class="main-content">
      <div v-if="(getModerator.id === loggedUser.id)">
        <h4 class="title">Group Settings</h4>
        <div class="photo-container">
          <div class="author-thumb d-flex group-avatar">
            <img :src="getGroupImagePath(group)" alt="author" class="fit-contain" />
          </div>
          <div class="photo-buttons">
            <SButtonMaterial text="CHANGE GROUP PHOTO" color="primary" class="btn-size" textColor="white" @button="openModalImage"/>
            <SButtonMaterial text="REMOVE" color="transparent" class="btn-size" textColor="danger" @button="removeImage"/>
          </div>
        </div>
        <form>
            <div>
              <SInput type="text" label="Group name" size="md" v-model="newName" required/>
              <span v-if="emptyName" style="color: red;">{{ emptyNameWarning }}</span>
            </div>
            <div class="select-privacity w-25">
              <select class="form-control group-privacy" v-model="newPrivacy">
                <option disabled hidden class="select-label" value="privacy">Privacy</option>
                <option value="1">Public</option>
                <option value="2">Private</option>
                <option value="3">Hidden</option>
              </select>
            </div>
            <div class="w-100">
              <div class="col col-lg-6 col-md-6 col-sm-12 col-12 group-description">
                <div class="form-group label-floating">
                  <label class="control-label"
                    >About the group</label
                  >
                  <textarea
                    class="form-control"
                    v-model="newDescription"
                    maxlength="300"
                  ></textarea>
                  <div class="max-description-number"
                  v-text="
                    `Maximum 300 characters (` +
                    (maxDescription - this.newDescription.length) +
                    ` remaining)`
                  "
                ></div>
                </div>
              </div>
            </div>
        </form>
        <div class="update-btn">
          <SButtonMaterial text="UPDATE" color="primary" class="btn-size" textColor="white" @button="saveChanges"/>
        </div>
  
  
        <GroupMembersSettings />
  
        <Modal
          id="groupUpdateStatus"
          buttonName="OK"
          title="Group Settings"
          ref="modal"
          @button="closeModal()"
          @hide="closeModal()"
          >
          <div data-cy="modalChangeEmailResult">{{ modalMessage }}</div>
        </Modal>
        <Modal
          id="groupUpdateImage"
          buttonName="OK"
          title="Change group image"
          ref="modal"
          @button="closeModal()"
          >
          <NewGroupImage @file="saveNewImage"/>
        </Modal>
  
      </div>
      <div v-else class="ui-block">
        <div class="ui-block-title">
          <h6 class="title text-danger">To access the group settings you need to be the moderator</h6>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import GroupHelper from '@/mixins/GroupHelper.vue';
import UserHelper from '../../mixins/UserHelper.vue';
import SButtonMaterial from '../../material-components/atoms/SButtonMaterial.vue';
import SInput from "@/components/atoms/SInput";
import GroupMembersSettings from './GroupMembersSettings.vue';
import Modal from '../atoms/Modal.vue';
import NewGroupImage from './NewGroupImage.vue';

export default {
  name: "GroupSettings",
  components: { SButtonMaterial, SInput, GroupMembersSettings, Modal, NewGroupImage },
  mixins: [GroupHelper, UserHelper],
  props: ["group"],
  data () {
    return {
      newName: '',
      newDescription: '',
      newPrivacy: "privacy",
      modalMessage: '',
      emptyName: false,
      emptyNameWarning: 'Group name cannot be empty',
      maxDescription: 300,
    }
  },
  methods: {
    async saveChanges() {
      if (!this.newName) {
        this.emptyName = true
        return
      } else {
        this.emptyName = false
      }
      const newGroupSettings = {
        ...this.group,
        name: this.newName,
        privacy: this.newPrivacy === "privacy" ? this.group.privacy : this.newPrivacy,
        description: this.newDescription
      };
      const response = await this.updateGroupSettings(newGroupSettings);
      this.modalMessage = response.result
      $("#groupUpdateStatus").modal("show");
    },
    closeModal() {
      this.$refs.modal.closeModal();
      location.reload()
    },
    openModalImage() {
      $("#groupUpdateImage").modal("show");
    },
    async saveNewImage(file) {
      await this.saveGroupImage({ groupId: this.group.id, groupImg: file })
    },
    removeImage() {
      this.removeGroupImage(this.group.id)
      location.reload()
    }
  },
  mounted() {
    setTimeout(() => {
      this.newName = this.group.name
      this.newDescription = this.group.description
    },1000)
  },

};

</script>

<style scoped>
  .group-settings-container {
    padding-left: 8px;
    width: 100%;
  }
  .max-description-number {
    display: flex;
    justify-content: flex-end;
  }
  .title {
    font-weight: 500;
    letter-spacing: 1px;
    margin-bottom: 3rem;
  }
  form {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .main-content {
    background-color: white;
    padding: 3rem;
  }
  .group-avatar {
    width: 100px;
  }
  .photo-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 30px;
  }
  .photo-buttons {
    margin-left: 15px;
    display: flex;
    flex-direction: column;
  }

  .group-privacy, option{
    color: #888da8;
    font-weight: 500;
    letter-spacing: 1px;
  }
  .update-btn {
    display: flex;
    justify-content: right;
  }
  .btn-size {
    width: 200px;
  }

  .select-privacity{
    min-width: 88px;
  }
  
  @media screen and (max-width:576px) {
    .photo-container{
      flex-direction: column;
    }  
    .main-content{
      padding: 16px;
    }
    .select-privacity{
      margin-bottom: 8px;
    }
  }
  @media screen and (max-width:1023px) {
    .group-settings-container {
      padding: 0 8px;
    }
  }
  .group-description {
    margin-bottom: 15px;
    flex: 100%;
    max-width: 100%;
    padding: 0;
  }
</style>
<style>
  .form-control-lg {
    padding: 1.5rem !important;
  }
  label {
    font-weight: 500;
  }
</style>
